<template>
  <!--
    The offset was `-ml-3`, a physical margin: in Arabic it pulled the button further into the
    title instead of out towards the edge. `-ms-3` is the same 12px against whichever edge the
    line starts at.

    The measured box on the conversation list was 14×24 — the smallest control in the product,
    and the one that opens the navigation drawer on a phone. `sidemenu-icon` is what
    `_responsive.scss` raises to 44×44 below `md`; it is also the stable hook a test can hold,
    which the utility chain was not.
  -->
  <woot-button
    :size="size"
    variant="clear"
    color-scheme="secondary"
    class="sidemenu-icon -ms-3 text-black-900 dark:text-slate-300"
    icon="list"
    @click="onMenuItemClick"
  />
</template>

<script>
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  props: {
    size: {
      type: String,
      default: 'small',
    },
  },
  methods: {
    onMenuItemClick() {
      bus.$emit(BUS_EVENTS.TOGGLE_SIDEMENU);
    },
  },
};
</script>
